import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { algoliaSearch } from './Reducers/AlgoliaSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { facetedSearch } from "./Reducers/FacetedSearch.reducer";
import { myPage } from './Reducers/MyPage.reducer';
import { checkout } from "./Reducers/Checkout.reducer";
import { lightboxImages } from './Reducers/LightboxImages.reducer';
import { sizePicker } from './Reducers/SizePicker.reducer';
import { shopTheLook } from './Reducers/ShopTheLook.reducer';
import { avardaCheckout } from "@motillo/avarda-checkout";
import { overlay } from "./Reducers/Overlay.reducer"
import { sizeGuide } from "./Reducers/SizeGuide.reducer"
import { loadMore } from "./Reducers/LoadMore.reducer"
import { favorites } from "./Reducers/Favorites.reducer"
import { productReviews } from "./Reducers/ProductReviews.reducer"


const app = combineReducers({
    cart,
    checkout,
    quickSearch,
    algoliaSearch,
    navigation,
    myPage,
    facetedSearch,
    lightboxImages,
    sizePicker,
    shopTheLook,
    avardaCheckout,
    overlay,
    sizeGuide,
    loadMore,
    favorites,
    productReviews
});

export default app;